module.exports = __webpack_public_path__ + "img/list_D10D.f1186137.png";